var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 22.6666C16.7338 22.6666 17.3307 23.2636 17.3307 24C17.3307 24.7364 16.7338 25.3333 15.9974 25.3333C15.261 25.3333 14.6641 24.7364 14.6641 24C14.6641 23.2636 15.261 22.6666 15.9974 22.6666Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 14.6666C16.7338 14.6666 17.3307 15.2636 17.3307 16C17.3307 16.7364 16.7338 17.3333 15.9974 17.3333C15.261 17.3333 14.6641 16.7364 14.6641 16C14.6641 15.2636 15.261 14.6666 15.9974 14.6666Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 6.66663C16.7338 6.66663 17.3307 7.26359 17.3307 7.99996C17.3307 8.73633 16.7338 9.33329 15.9974 9.33329C15.261 9.33329 14.6641 8.73633 14.6641 7.99996C14.6641 7.26359 15.261 6.66663 15.9974 6.66663Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.824eeece6a9cb8f9a91d73aefe99b20b.svg";
export { ForwardRef as ReactComponent };